import React from 'react';
import { useTranslation } from 'react-i18next';
import FloodVideo from '../assets/videos/Fllod Senario -updated1.mp4';
import FloodPoster from '../assets/images/digitalTwin.png';
import CarbonVideo from '../assets/videos/Carbon Senario updated3.mp4';
import CarbonPoster from '../assets/images/Carbon.png';
import FireVideo from '../assets/videos/Fire Responder Senarion updated2.mp4';
import FirePoster from '../assets/images/Fire.png';

const DigitalTwin = () => {
  const { t } = useTranslation();

  return (
    <div className="digital-twin-page">
      {/* Section 1: Introduction */}
      <div className="section">
        <h2 style={{ color: 'black' }}>{t('digital-twin-sub')}</h2>
        <div className="subtitle-section">
          <p>{t('digital-twin-subtitle-section1')}</p>
          <p>{t('digital-twin-subtitle-section2')}</p>
        </div>
      </div>

      {/* Section 2: Importance of Digital Twin */}
      <div className="section">
        <h2 style={{ color: 'black' }}>{t('dt_importance')}</h2>
        <div className="subtitle-section">
          <p>{t('dt_importance_text1')}</p>
          <ul>
            <li>{t('dt_importance_i1')}</li>
            <li>{t('dt_importance_i2')}</li>
            <li>{t('dt_importance_i3')}</li>
          </ul>
        </div>
      
        <h2 style={{ color: 'black', fontSize: '18px' }}>{t('dt_example')}</h2>

        {/* Flood Simulation Scenario */}
        <h4 style={{ color: 'black', fontSize: '14px' }}>{t('dt_example1')}</h4>
        <div className="video-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <video controls width="100%" height="450" poster={FloodPoster} autoplay>
            <source src={FloodVideo} type="video/mp4" />
            <source src="assets/videos/fire-simulation.webm" type="video/webm" />
            {t('video_not_supported')}
          </video>
        </div>
        <br></br>
        {/* Carbon Simulation Scenario */}
        <h4 style={{ color: 'black', fontSize: '14px' }}>{t('digitalTwin_CarbonScenario')}</h4>
        <div className="video-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <video controls width="100%" height="450" poster={CarbonPoster} autoplay>
            <source src={CarbonVideo} type="video/mp4" />
            <source src="assets/videos/fire-simulation.webm" type="video/webm" />
            {t('video_not_supported')}
          </video>
        </div>
        <br></br>
        {/* Fire Simulation Scenario */}
        <h4 style={{ color: 'black', fontSize: '14px' }}>{t('digitalTwin_FireScenario')}</h4>
        <div className="video-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <video controls width="100%" height="450" poster={FirePoster} autoplay>
            <source src={FireVideo} type="video/mp4" />
            <source src="assets/videos/fire-simulation.webm" type="video/webm" />
            {t('video_not_supported')}
          </video>
        </div>

      {/* Button to open Digital Twin app */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        {/* <a href={t('digital-twin_url')} target="_blank" rel="noopener noreferrer">
          <button className="button">{t('Open_App')}</button>
        </a> */}
      </div>
    </div></div>
  );
};

export default DigitalTwin;
